import React from "react";
import { ReactTableDefaults } from "react-table-6";

// Mientras la primera carga no trae filas se muestra un esqueleto en lugar del
// mensaje de vacío, para no anunciar "sin registros" antes de tiempo.
const SKELETON_ROWS = [0, 1, 2, 3];

const DataTableSkeleton = () => (
  <div className="dhn-data-table__skeleton" aria-hidden="true">
    {SKELETON_ROWS.map((row) => (
      <div key={row} className="dhn-data-table__skeleton-row">
        <span />
        <span />
        <span />
      </div>
    ))}
  </div>
);

// ReactTable monta su estado vacío fuera de la tabla y lo centra sobre todo el
// componente; con minRows={0} queda encima del encabezado. Aquí se dibuja
// dentro del cuerpo, que reserva un alto mínimo mientras no hay filas.
export default function DataTableTbody({
  children,
  emptyText,
  showSkeleton,
  ...props
}) {
  return (
    <ReactTableDefaults.TbodyComponent {...props}>
      {children}
      {showSkeleton && <DataTableSkeleton />}
      {emptyText && (
        <div className="dhn-data-table__empty">
          <i className="fa fa-inbox" aria-hidden="true" />
          <span>{emptyText}</span>
        </div>
      )}
    </ReactTableDefaults.TbodyComponent>
  );
}
